<template>
    <span v-html="markup"></span>
</template>

<script>

import htmldiff from '@/libs/htmldiff'

export default {
  props: ['current', 'version'],
  created: async function () {
    let c = ' '
    if (this.current) {
      c = this.current
    }
    let v = ' '
    if (this.version) {
      v = this.version
    }
    this.markup = htmldiff(v.replace(/(\r\n|\n|\r)/gm, "<br />"), c.replace(/(\r\n|\n|\r)/gm, "<br />"))
  },
  data () {
    return {
      markup: ''
    }
  }
}
</script>

<style>
  del {
    background-color: orangered;
  }
  ins {
    background-color: lightgreen;
  }
</style>
